import React from 'react';
import { Language } from '@lialo/common/lib/language';
import { LocalStorage, PaymentApi, PaymentServiceProvider } from '../common/services';
import { GOOGLE_MERCHANT_ID } from './config';

interface IProps {
  apiBaseUrl: string;
  apiContractVersion: number;
  getIdToken: () => Promise<string | null>;
  onVersionError: (error: Error) => void;
  language: Language;
  children: React.ReactNode;
}

interface PaymentConfig {
  language: Language;
  googleMerchantId: string | undefined;
}

const PaymentConfigContext = React.createContext<PaymentConfig | null>(null);
const localStorage = new LocalStorage();

export const PaymentConfigProvider = ({
  apiBaseUrl,
  apiContractVersion,
  getIdToken,
  language,
  onVersionError,
  children,
}: IProps) => {
  const paymentApi = React.useMemo(() => new PaymentApi(apiBaseUrl, apiContractVersion, getIdToken, onVersionError), [
    apiBaseUrl,
    apiContractVersion,
    getIdToken,
    onVersionError,
  ]);

  return (
    <PaymentConfigContext.Provider value={{ language, googleMerchantId: GOOGLE_MERCHANT_ID }}>
      <PaymentServiceProvider paymentApi={paymentApi} localStorage={localStorage}>
        {children}
      </PaymentServiceProvider>
    </PaymentConfigContext.Provider>
  );
};

export function usePaymentConfig(): PaymentConfig {
  const config = React.useContext(PaymentConfigContext);
  if (config === null) {
    throw new Error('PaymentConfigContext is not available, wrap your component with PaymentConfigProvider');
  }
  return config;
}
